module.exports = __webpack_public_path__ + "FondoContenido.96d56d69236fcdb1fde2.png";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/Servicios/FondoContenido.png
// module id = ../../../../../src/assets/Servicios/FondoContenido.png
// module chunks = styles